import { combineReducers } from 'redux'
import { UserActions } from './actions'

// States' definition
export interface IUserSate {
    isFetching: boolean
    user?: any
    isValidated: boolean
    token?: string
    /** Set on login before Me completes; merged into user when profile loads. */
    loginShowUsSizes?: boolean
}

export interface State {
    user: IUserSate
}

const userReducer = (state: IUserSate = {
    isFetching: false,
    isValidated: false
}, action: UserActions): IUserSate => {
    switch (action.type) {
        case 'LOGIN_USER_SUCCESS':
            return { ...state, token: action.token }
        case 'USER_LOGIN_PREFERENCES_LOADED':
            return { ...state, loginShowUsSizes: action.showUsSizes }
        case 'USER_IS_VALID_SUCCESS': {
            const showUsSizes = state.loginShowUsSizes !== undefined
                ? state.loginShowUsSizes
                : action.user.showUsSizes;
            return {
                ...state,
                user: { ...action.user, showUsSizes },
                loginShowUsSizes: undefined,
                isValidated: true,
            };
        }
        case 'USER_IS_VALID_ERROR':
            return { ...state, isValidated: true, user: null }
        case 'LOGOUT_USER_SUCCESS':
            return { ...state, user: null, loginShowUsSizes: undefined }
        case 'USER_SIZE_DISPLAY_UPDATED':
            if (!state.user) {
                return state;
            }
            return {
                ...state,
                user: { ...state.user, showUsSizes: action.showUsSizes },
            }
    }
    
    return state
}

export default combineReducers<State>({
    user: userReducer
})